import React from 'react'
import { Button } from 'antd';
import { useMsal } from "@azure/msal-react";
import { loginRequest, graphRequest } from '../config/msal/authConfig';

const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(graphRequest).catch(e => {
                //console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(graphRequest).catch(e => {
                // console.log(e);
            });
        }
    }
    return (
        <>
            <Button type="primary" onClick={() => handleLogin("popup")}>Sign in</Button>
        </>
    )
}

export default SignInButton